import { UserAvatar } from "@cmp-src/data-display/UserAvatar/UserAvatar";
import { cn } from "@gettactic/helpers";
import React from "react";

export type UserInfoProps = {
    name: string;
    profile_photo_url?: string;
    title?: string;
    badge?: React.ReactNode;
    classNames?: string;
};

export const UserInfo = ({
                             name,
                             profile_photo_url,
                             title,
                             badge,
                             classNames
                         }: UserInfoProps) => {
    return (
        <div
            className={cn(
                "flex w-full items-center justify-start rounded-brand border border-neutral-100 p-3",
                classNames
            )}
        >
            <div className="relative flex-shrink-0">
                {badge}
                <UserAvatar
                    user={{
                        name,
                        profile_photo_url
                    }}
                    size="sm2"
                />
            </div>
            <div className="ml-2 flex flex-grow flex-col justify-start gap-1 overflow-hidden align-center">
                <div className="truncate text-sm">
          <span className="truncate font-inter font-regular text-neutral-1000 text-sm">
            {name}
          </span>
                </div>
                {!!title && (
                    <div className="truncate font-regular text-neutral-600 text-xs">
                        <span className="truncate font-inter">{title}</span>
                    </div>
                )}
            </div>
        </div>
    );
};
